import React from 'react';

const ThreeDoctors: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M64.663 27c-8.404 0-15.223 6.823-15.223 15.23 0 8.408 6.82 15.23 15.223 15.23s15.222-6.822 15.222-15.23c0-8.407-6.82-15.23-15.222-15.23zm26.76 74.05V80.791c0-7.873-6.19-15.683-17.647-18.415l-9.47 7.938-9.388-7.873c-11.038 2.635-17 9.797-17 18.334v20.259m40.562-.292V90.266m-27.634 10.476V90.266"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M52.51 78.334h5.09"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M28.044 37.219c-7.24 0-13.122 5.885-13.122 13.128s5.883 13.129 13.122 13.129c7.24 0 13.122-5.886 13.122-13.129 0-7.243-5.882-13.128-13.122-13.128zm-11.667 63.556v-9.022"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M17.573 81.454h4.395"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M41.845 69.895c-1.745-.922-3.717-1.666-5.931-2.183l-8.16 6.839-8.097-6.79C10.14 70.023 5 76.215 5 83.572v17.477m95.845-63.83c7.239 0 13.122 5.885 13.122 13.128s-5.883 13.129-13.122 13.129c-7.24 0-13.122-5.886-13.122-13.129 0-7.243 5.882-13.128 13.122-13.128zm11.684 63.556v-9.022"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M95.82 81.454h-4.396"
    ></path>
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M87.06 69.895c1.746-.922 3.717-1.666 5.931-2.183l8.161 6.839 8.096-6.79c9.518 2.263 14.657 8.455 14.657 15.812v17.477"
    ></path>
  </svg>
);

export default ThreeDoctors;
